export const getData = (localStorageKey, defaultValue = false) => {
  try {
    const data = localStorage.getItem(localStorageKey);

    if (data === null) {
      return defaultValue;
    }

    return JSON.parse(data);
  } catch (error) {
    // console.error(`Error getting data from localStorage with key "${localStorageKey}":`, error);
    return defaultValue;
  }
};

export const mergeObject = (localStorageKey, values) => {
  const item = JSON.parse(localStorage.getItem(localStorageKey)) || {};

  Object.keys(values).forEach((k) => {
    if (!item[k]) {
      item[k] = values[k];
    }
  });
  localStorage.setItem(localStorageKey, JSON.stringify(item));
  return item;
};

export const removeKeys = (localStorageKey, keys) => {
  const item = JSON.parse(localStorage.getItem(localStorageKey)) || {};

  keys.forEach((k) => {
    if (item[k]) {
      delete item[k];
    }
  });
  localStorage.setItem(localStorageKey, JSON.stringify(item));
  return item;
};

export const addArrayItems = (localStorageKey, values) => {
  let items = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  items = items.concat([
    ...values,
  ]);
  localStorage.setItem(localStorageKey, JSON.stringify(items));
};

export const addItemToFrontWithLimit = (localStorageKey, item, limit = 10, unique = false) => {
  const items = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const existingIndex = items.findIndex(i => JSON.stringify(i) === JSON.stringify(item));
  if (unique && existingIndex !== -1) {
    items.splice(existingIndex, 1);
  }
  items.unshift(item);
  if (items.length > limit) {
    items.pop();
  }

  // Lưu lại danh sách vào localStorage
  localStorage.setItem(localStorageKey, JSON.stringify(items));
};


export const setRecentImportedInvoices = (object) => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  const companyId = currentUser.company.company_id;
  const todayKey = new Date().toLocaleDateString();
  localStorage.setItem(`recentImportedInvoices_${companyId}`, JSON.stringify({
    [todayKey]: object,
  }));
};
export const getRecentImportedInvoices = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  const companyId = currentUser.company.company_id;
  const importedInvoices = JSON.parse(localStorage.getItem(`recentImportedInvoices_${companyId}`));
  if (!importedInvoices) {
    return [];
  }
  return importedInvoices[new Date().toLocaleDateString()] || [];
};

export const addRecentImportedInvoices = (invoices) => {
  const inv = getRecentImportedInvoices();
  invoices.forEach((invoice) => {
    if (inv.findIndex(i => !!i.id && i.invoice_no === invoice.invoice_no) === -1) {
      inv.unshift(invoice);
    }
  });
  setRecentImportedInvoices(inv);
  return inv;
};

export const removeRecentImportedInvoices = (invoice) => {
  let inv = getRecentImportedInvoices();
  inv = inv.filter(i => i.invoice_no !== invoice.invoice_no);
  setRecentImportedInvoices(inv);
  return inv;
};

export default {
  getData,
  mergeObject,
  removeKeys,
  addArrayItems,
  addItemToFrontWithLimit,
  addRecentImportedInvoices,
  removeRecentImportedInvoices,
  setRecentImportedInvoices,
  getRecentImportedInvoices,
};



// WEBPACK FOOTER //
// ./src/utils/local-storage.js